import Cookies from 'universal-cookie';
import { SOCIAL_SIGNUP_COOKIE } from '../../shared/constants';

export const setSocialSignupProviderCookie = () => {
    const cookies = new Cookies();

    cookies.set(SOCIAL_SIGNUP_COOKIE, true, {
        secure: true,
        sameSite: 'lax',
        maxAge: 1440,
        path: '/',
    });
};
